import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export function fileUrl(pathOrId) {
  if (!pathOrId) return "";
  if (pathOrId.startsWith("http")) return pathOrId;
  if (pathOrId.startsWith("/api/")) return `${BACKEND_URL}${pathOrId}`;
  return `${API}/files/${pathOrId}`;
}
